import skeleton from './compressed/skeleton.webp';

export { skeleton };
